/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Registry_Kn_Section_HintInputs */

const cs_property_registry_kn_section_hint = /** @type {(inputs: Property_Registry_Kn_Section_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budova, parcely a jednotky podle RÚIAN adresního místa (zdarma přes KN REST).`)
};

const en_property_registry_kn_section_hint = /** @type {(inputs: Property_Registry_Kn_Section_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building, parcels, and units from a RÚIAN address point (free KN REST).`)
};

/**
* | output |
* | --- |
* | "Building, parcels, and units from a RÚIAN address point (free KN REST)." |
*
* @param {Property_Registry_Kn_Section_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_kn_section_hint = /** @type {((inputs?: Property_Registry_Kn_Section_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Kn_Section_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_kn_section_hint(inputs)
	return cs_property_registry_kn_section_hint(inputs)
});